import produce, { enableMapSet } from 'immer';
import { useState, useEffect, useMemo } from 'react';
import { NotifyAction } from './createNotifier';
enableMapSet();
const useNotifier = (notifier, callback) => {
  const [notifications, setNotifications] = useState(new Map());
  useEffect(() => {
    if (callback) {
      const unsubscribe = notifier.subscribe(callback);
      return unsubscribe;
    }
    return () => {};
  }, [callback, notifier]);
  useEffect(() => {
    const unsubscribe = notifier.subscribe((action, notification) => {
      if (action === NotifyAction.SEND) {
        setNotifications(produce(draft => {
          draft.set(notification.id, notification);
        }));
      }
      if (action === NotifyAction.DISMISS) {
        setNotifications(produce(draft => {
          draft.delete(notification.id);
        }));
      }
    });
    return unsubscribe;
  }, [notifier]);
  const values = useMemo(() => {
    const {
      send,
      dismiss,
      info,
      error,
      warning,
      success
    } = notifier;
    return {
      notifications,
      send,
      info,
      error,
      warning,
      success,
      dismiss
    };
  }, [notifications, notifier]);
  return values;
};
const createUseNotifier = notifier => {
  return callback => useNotifier(notifier, callback);
};
export default createUseNotifier;